const PREFIX =
  'offline_lobby_'

const OfflineLobbyService = {
  saveLobby(
    eventSlug,
    data,
  ) {
    if (
      !eventSlug ||
      !data
    ) {
      return
    }

    localStorage.setItem(
      `${PREFIX}${eventSlug}`,
      JSON.stringify(
        data,
      ),
    )
  },

  getLobby(
    eventSlug,
  ) {
    if (
      !eventSlug
    ) {
      return null
    }

    try {
      const value =
        localStorage.getItem(
          `${PREFIX}${eventSlug}`,
        )

      return value
        ? JSON.parse(
            value,
          )
        : null
    } catch (
      error
    ) {
      console.error(
        '[OFFLINE LOBBY] Erro ao carregar lobby:',
        error,
      )

      return null
    }
  },

  removeLobby(
    eventSlug,
  ) {
    if (
      !eventSlug
    ) {
      return
    }

    localStorage.removeItem(
      `${PREFIX}${eventSlug}`,
    )
  },
}

export default OfflineLobbyService